/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class FractionDisplay extends Phaser.GameObjects.Container {
  constructor(scene, cont) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;
    this.cont = cont;

    this.line = ABCyaPhaser.Images.addImage(50, 100, '-', this).setScale(2, 1.5);

    this.numeratorDisplay = this.scene.add.bitmapText(5, -30, 'asapBoldLarge', '1', 120).setTintFill('0xd3681b');
    this.add(this.numeratorDisplay);
    this.denominatorDisplay = this.scene.add.bitmapText(5, 100, 'asapBoldLarge', '12', 120).setTintFill('0xd3681b');
    this.add(this.denominatorDisplay);

    this.lineWidth = this.line.getBounds().width;
  }

  updateDisplay(fraction) {
    this.setVisible(true);
    this.fraction = fraction;
    this.numeratorDisplay.text = this.fraction.numerator.toString();
    this.denominatorDisplay.text = this.fraction.denominator.toString();
    this.numeratorDisplay.x = this.lineWidth / 2 - this.numeratorDisplay.width / 2;
    this.denominatorDisplay.x = this.lineWidth / 2 - this.denominatorDisplay.width / 2;
  };

  showRandomFraction() {
    const f = {};
    f.numerator = Phaser.Math.Between(1, 4);
    f.denominator = Phaser.Math.Between(4, 12);
    this.numeratorDisplay.text = f.numerator.toString();
    this.denominatorDisplay.text = f.denominator.toString();
    this.numeratorDisplay.x = this.lineWidth / 2 - this.numeratorDisplay.width / 2;
    this.denominatorDisplay.x = this.lineWidth / 2 - this.denominatorDisplay.width / 2;
  };
}